/**
 * This is the twofa routes configuration.
 * Only configure routes in this file.
 * @memberOf twofa Module
 * @namespace twofa Routes
 */
import twofaOtpTemplate from './2fa.otp.html';

/**
 * @name config
 * @desc Configures the routes.
 * @param $stateProvider
 * @memberOf twofa Module.twofa Routes
 * @ngInject
 */
var config = function ($stateProvider) {
	/* Create the twofa state and assign the template and controller. */
	$stateProvider
		.state('login.2fa.otp', {
			url: '/otp',
			template: twofaOtpTemplate,
			controller: 'twofaOtpController',
			controllerAs: 'vm'
		});
}

export default config;


// WEBPACK FOOTER //
// ./src/login/2fa/otp/2fa.otp.route.js